import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "Dashboard": "Dashboard",
      "Projects": "Projects",
      "Direction": "Direction",
      "Pick your style": "Pick your style",

      // Dashboard Cards
      "Advanced Projects Count": "Advanced Projects Count",
      "On Track Projects Count": "On Track Projects Count",
      "Delayed Projects Count": "Delayed Projects Count",
      "Average Completed Project Value": "Average Completed Project Value",
      "Average Completion Rate and Project Count": "Average Completion Rate and Project Count",
      "Project Count": "Project Count",
      "Average Project Value": "Average Project Value",

      // Charts
      "Project Achievement Comparison": "Project Achievement Comparison",
      "Project Timeline Achievement Comparison": "Project Timeline Achievement Comparison",

      // Table
      "Top 10 Projects by Achievement": "Top 10 Projects by Achievement",
      "Loading...": "Loading...",
      "No data available.": "No data available.",
      "Project Code": "Project Code",
      "Project Name": "Project Name",
      "Elapsed Period": "Elapsed Period",
      "Completion Rate": "Completion Rate",
      "Track": "Track",
      "Actions": "Actions",
      "Advanced": "Advanced",
      "Delayed": "Delayed",
      "On Track": "On Track",
      "Details": "Details",
      "Owner": "Owner",
      "Consultant": "Consultant",
      "Contractor": "Contractor",
      "Project Start Date": "Project Start Date",
      "Contract Duration": "Contract Duration",
      "Approved Extracts Value": "Approved Extracts Value",
      "Project Value": "Project Value",
      "Contract Value": "Contract Value",
      "Change Rate": "Change Rate",
      "Approved Requests": "Approved Requests",
      "Under Evaluation Requests": "Under Evaluation Requests",
      "Request Type": "Request Type",
      "Request Number": "Request Number",
      "Submission Date": "Submission Date",
      "Progress Percentage": "Progress Percentage",
      "No weather data available.": "No weather data available.",
    }
  },
  ar: {
    translation: {
      "Dashboard": "لوحة التحكم",
      "Projects": "المشاريع",
      "Direction": "الاتجاه",
      "Pick your style": "اختر أسلوبك",

      // Dashboard Cards
      "Advanced Projects Count": "عدد المشاريع المتقدمة",
      "On Track Projects Count": "عدد المشاريع على المسار",
      "Delayed Projects Count": "عدد المشاريع المتأخرة",
      "Average Completed Project Value": "متوسط قيمة الاعمال المنجزة في المشاريع",
      "Average Completion Rate and Project Count": "متوسط نسبة الانجاز ف المشاريع وعدد المشاريع",
      "Project Count": "عدد المشاريع",
      "Average Project Value": "متوسط قيمة المشاريع",

      // Charts
      "Project Achievement Comparison": "مقارنة نسب الإنجاز في المشاريع",
      "Project Timeline Achievement Comparison": "مقارنة نسب الانجاز في المشاريع حسب الجدول الزمني",

      // Table
      "Top 10 Projects by Achievement": "أفضل 10 مشاريع حسب الإنجاز",
      "Loading...": "جاري التحميل...",
      "No data available.": "لا توجد بيانات.",
      "Project Code": "رمز المشروع",
      "Project Name": "اسم المشروع",
      "Elapsed Period": "الفترة المنقضية",
      "Completion Rate": "نسبة الإنجاز",
      "Track": "المسار",
      "Actions": "عمليات",
      "Advanced": "متقدم",
      "Delayed": "متأخر",
      "On Track": "في المسار",
      "Details": "تفاصيل",
       "Owner": "المالك",
      "Consultant": "الاستشاري",
      "Contractor": "المقاول",
      "Project Start Date": "تاريخ بداية المشروع",
      "Contract Duration": "مدة العقد",
      "Approved Extracts Value": "قيمة المستخلصات المعتمدة",
      "Project Value": "قيمة المشروع",
      "Contract Value": "قيمة العقد",
      "Change Rate": "معدل التغير",
      "Approved Requests": "الطلبات المعتمدة",
      "Under Evaluation Requests": "الطلبات تحت التقييم",
      "Request Type": "نوع الطلب",
      "Request Number": "رقم الطلب",
      "Submission Date": "تاريخ التقديم",
      "Progress Percentage": "نسبة التقدم",
      "No weather data available.": "لا توجد بيانات طقس متاحة حالياً",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "ar",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
